/**
 * Utilities for tweens.
 */
export class TweenUtil {
    static recover(animation) {
        if (animation != null) {
            const time = animation.time();
            animation.invalidate().restart().seek(time);
        }
    }
}
//# sourceMappingURL=TweenUtil.js.map